import { combineReducers } from 'redux'
import emailConfigurationReducer from './configuration'
import emailSignatureReducer from './signature'

export default combineReducers({
  configuration: emailConfigurationReducer,
  signature: emailSignatureReducer,
})
